<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Contactez-nous" />
            <ContactComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ContactComp from '../Contact/ContactComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ContactUsPage',
    components: {
        NavBar,
        PageTitle,
        ContactComp,
        FooterComp,
    }
}
</script>